import { useState, useEffect, useContext, useRef } from "react";
import { MdOutlineMyLocation } from 'react-icons/md';
import { AppContext } from "../App";
import { processTimer } from "../CoreHelper";
import BrazilianCheckers from "../models/BrazilianCheckers";

export default function View(props) {

  const app = useContext(AppContext);
  const [ type, setType ] = useState(props.type);
  const [ timer, setTimer ] = useState("--:--");
  const timerId = useRef(null);

  useEffect(() => {
    setType(props.type);

    if(timerId.current) {
      //clear the old timer
      clearInterval(timerId.current);
      timerId.current = setInterval(() => {
        setTimer(getTimer());
      }, 1000);
    } else {
      timerId.current = setInterval(() => {
        setTimer(getTimer());
      }, 1000);
    }

    return () => {
      if(timerId.current) {
        clearInterval(timerId.current)
      }
    }

  }, [ props.type, app.gameData, app.currentServerTimestamp ])

  function getPiecesCount() {
    let count = 0;
    if(app.gameData) {
      let kingValue = null;
      let pawnValue = null;
      if(type === 'player') {
        kingValue = 3;
        pawnValue = 1;
      } else {
        kingValue = 4;
        pawnValue = 2;
      }

      if(kingValue && pawnValue) {
        const board = JSON.parse(app.gameData.boardData).board;
        board.forEach((row, rowIndex) => {
          row.forEach((col, colIndex) => {
            let pieceValue = BrazilianCheckers.getCellValue({ board, row: rowIndex, col: colIndex });

            if(pieceValue === kingValue || pieceValue === pawnValue) {
              ++count
            }
          })
        });
      }
    }

    return count;
  }

  function getPieceColor() {
    if(type === 'player') {
      return 'black';
    } else {
      return 'white';
    }
  }

  function isCurrentPlayer() {
    if(type === 'player') {
      return (app.gameData && app.gameData.currentPlayer === app.gameData.playerId && app.gameData.status === 'ongoing')
    } else {
      return (app.gameData && app.gameData.currentPlayer === app.gameData.opponentId && app.gameData.status === 'ongoing')
    }
  }

  function getName() {
    if(type === 'player') {
      if(app.gameData && app.gameData.playerInfo) {
        return app.gameData.playerInfo.username
      }
    } else {
      if(app.gameData && app.gameData.opponentInfo) {
        return app.gameData.opponentInfo.username
      }
    }
  }

  function getTimer() {
    if(isCurrentPlayer() && app.gameData && app.gameData.status === 'ongoing') {
      return processTimer(app.gameData, app.currentServerTimestamp)
    } else {
      return "--:--";
    }
  }

  return (
    <div className={(isCurrentPlayer()) ? "coreShadow core-bg-maronish" : "coreShadow core-bg-bluish"} style={{ padding: "5px", maxWidth: "200px", minWidth: "160px", margin: "0 auto", transition: "none !important" }}>
      <h6 className="mOneLineText font-bold" style={{ textTransform: "capitalize", fontSize: "12px", margin: "0" }}>{getName() || "...."}</h6>
      <div className="d-flex">
        <div
          className="align-self-center text-center"
          style={{
            flexShrink: "0",
            width: "30px",
            height: "30px",
            background: getPieceColor(),
            color: (getPieceColor() === 'black') ? 'white' : 'black', 
          }}
        >
          <p style={{ fontSize: "15px", lineHeight: "30px" }} className="font-bold">{getPiecesCount()}</p>
        </div>

        <div
          className="align-self-center d-flex justify-content-between"
          style={{
            flexGrow: "1",
            paddingLeft: "5px",
            paddingRight: "0px",
            paddingTop: "0px",
            paddingBottom: "0px"
          }}
        >
          
          {
            (isCurrentPlayer()) ?
            <MdOutlineMyLocation 
              className="mNoMargin mNoPadding align-self-center text-success"
              size={20}
              style={{
              }}
            /> 
            :
            <MdOutlineMyLocation 
              className="mNoMargin mNoPadding align-self-center text-muted"
              size={20}
              style={{
                opacity: "0.5",
              }}
            /> 
          }
          <span
            className="align-self-center"
            style={{
              fontSize: "20px"
            }}
          >
            {timer}
          </span>
        </div>
      </div>
    </div>
  )
}